import React, {useState} from 'react';
import css from './Card.module.scss';
import CardTitle from "../Headings/CardTitle/CardTitle.jsx";
import PropTypes from 'prop-types';
import FlexContainer from "../FlexContainer/FlexContainer.jsx";
import DownArrow from "../Icons/DownArrow";
import UpArrow from "../Icons/UpArrow";

const Card = ({
  icon,
  title,
  titleColor,
  titleAlign = 'left',
  isExpandable = false,
  className,
  children,
  style,
  backgroundColor,
}) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const cardStyle = {
    ...style,
    ...(backgroundColor && { backgroundColor }),
  };

  return (
    <div className={`${css.card} ${className}`} style={cardStyle}>
      {title &&
        <div className={css.title} style={{justifyContent: titleAlign}}>
          {isExpandable ?
            <FlexContainer justifyContent="space-between" alignItems="center" width="100%">
              <CardTitle
                icon={icon ? icon : null}
                color={titleColor}
              >
                {title}
              </CardTitle>
              <div onClick={() => setIsExpanded(!isExpanded)} className={css.pointer}>
                {isExpanded ? <UpArrow width="20px" /> : <DownArrow width="20px" />}
              </div>
            </FlexContainer> :
            <CardTitle
              icon={icon ? icon : null}
              color={titleColor}
            >
              {title}
            </CardTitle>
          }
        </div>
      }
      {isExpanded &&
        <div className={css.cardContent}>
          {children}
        </div>
      }
    </div>
  );
};

Card.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string || PropTypes.object,
  titleAlign: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
};

export default Card;
